module.exports = __webpack_public_path__ + "media/images/special-offer-creator-economy-355a509b.png";